<template>
  <div class="playmusic">
    <div class="bottom-music">
      <!-- 左边缩略图 -->
      <div class="music-lt">
        <div class="lt-avator">
          <img
            :class="isStatus ? 'rotation' : 'rotation stop'"
            class="img"
            :src="audioInfo.coverUrl"
          />
        </div>
        <div class="lt-title" @click="onDetail(audioInfo.only)">
          <span class="title">{{ audioInfo.name }}</span>
        </div>
      </div>

      <!-- 环形进度条 -->
      <div class="music-rt">
        <div id="progressCircle" class="progress-circle">
          <svg
              id="mySvg"
              height="100%"
              width="100%"
              xmlns="http://www.w3.org/2000/svg"
          >
            <circle
                class="progress-background"
                cx="50%"
                cy="50%"
                fill="transparent"
                r="50%"
            />
            <circle
                :stroke-dasharray="dashArray"
                :stroke-dashoffset="dashOffset"
                class="progress-bar"
                cx="50%"
                cy="50%"
                fill="transparent"
                r="50%"
            />
          </svg>
        </div>

        <audio
          ref="player"
          :src="audioInfo.contentUrl"
          id="audio"
          @ended="ended"
        ></audio>
      </div>

      <!-- 右边图标 -->
      <div class="IconRight">
        <img
            :src="
            isStatus
              ? require('../../../assets/images/icon/audio_end2.png')
              : require('../../../assets/images/icon/audio_start2.png')
          "
            alt
            @click="operation"
        />
        <img
            alt
            src="../../../assets/images/icon/audio_next_detail.png"
            @click="audioNext"
        />
      </div>
    </div>
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.0.0.js"></script>
<script>
import {Debounce, getCookie, is_weixin, TestUserAgent} from "@/assets/js/common.js";
import {addIntegral, inquireTime} from '@/utils/newMemberApiGlobal'

export default {
  data() {
    return {
      audioInfo: {}, //音频信息
      dashArray: 0, //圆形进度条
      current: 0,
      dashOffset: 0,
      isStatus: false, // 播放状态  false 暂停  true 播放
      isKq: "", //kq 凯琪页面 ye 育儿页面
      isTime: 0, //15 凯琪成长值 5育儿成长值
      readingArticleDuration: 10
    };
  },
  props: {
    playTime: {
      type: Number,
      default: 0,
    },
    //播放当前信息
    audioParams: {
      type: Object,
      require: true,
    },
    columName: {
      type: String,
      default: "育儿音频",
    },
    doctorName: {
      type: String,
      default: "",
    },
  },
  created() {
    inquireTime((data) => {
      this.readingArticleDuration = data.readingArticleDuration
    }, this)
  },
  watch: {
    // 当前音频播放进度时间
    playTime(val) {
      let audio = document.getElementById("audio");
      const {isios} = TestUserAgent();
      if (isios) {
        audio.addEventListener("canplay", function () {
          audio.currentTime = val;
        });
      } else {
        audio.currentTime = val;
      }
      audio.currentTime = val; //没有这行 最新一条音频联动会出问题
    },
    // 监听当前音频信息
    audioParams: {
      handler(newval, oldval) {

        if (newval.isKq) {
          this.isKq = newval.isKq;
        } else {
          this.isKq = "ye";
        }

        let audio = document.getElementById("audio");
        this.audioInfo = newval;
        console.log(newval)
        if (newval.isPlay) {


          setTimeout(() => {
            audio.play();
            this.autoplayAudio() //强制播放
            this.isStatus = true;
          }, 10);
        } else {
          //  this.$emit("addPalyNum");
          this.isStatus = false;
        }
      },
      deep: true,
      immediate: true,
    },
    current(val) {
      console.log(val);
      this.isTime = val;
      if (val == 10 && this.isStatus) {
        this.$emit("listenLogin");
      }
    },
    isTime(value) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (this.isKq == "kq") {
        if (value == this.readingArticleDuration && this.isStatus) {
          addIntegral({
            taskGroupCode: "YDWZ00002",
            crmId: userInfo?.crm_id
          }, this, '播放成功')
        }

      }

      if (this.isKq == "ye") {
        if (value == this.readingArticleDuration && this.isStatus) {
          addIntegral({
            taskGroupCode: "YDWZ00002",
            crmId: userInfo?.crm_id
          }, this, '播放成功')
        }
      }
    },
  },

  methods: {
    // 自动播放
    autoplayAudio() {
      let music = document.getElementById('audio')
      if (is_weixin) {
        if (window.WeixinJSBridge) {
          WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
            music.play()
          }, false);
        } else {
          document.addEventListener("WeixinJSBridgeReady", function () {
            WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
              music.play()
            });
          }, false);
        }
      } else {
        music.play()
      }
      this.status = true;
    },
    //跳转详情 mixins需要id来做判断
    newId() {
      return this.audioParams.id;
    },
    //未登陆听10s
    setAudioTime() {
      const num = 9;
      let audio = document.getElementById("audio");
      audio.currentTime = this.current = num;
    },
    //清楚播放时间
    clearTime() {
      let audio = document.getElementById("audio");
      audio.addEventListener("canplay", function () {
        audio.currentTime = 0;
      });
    },
    // 跳转详情
    onDetail(status) {
      this.$emit("senDetail", status ? 1 : 0); //1 最新列表跳详情 0 凯琪列表跳详情
    },
    //暂停设置时间
    getTime() {
      // const { audioTime } = this.$store.state.recordAudio;
      let audio = document.getElementById("audio");
      setTimeout(() => {
        audio.play();
        audio.pause();
        this.isStatus = false //解决状态不更新
      }, 300);
      // audio.addEventListener("pause", function() {
      // audio.currentTime = audioTime;
      // });
    },
    // 切换下一个音频
    audioNext: Debounce(function () {
      const {isios} = TestUserAgent();
      if (isios) {
        this.clearTime();
      }

      this.$emit("audio-end", this.audioInfo.only ? 1 : 0);
      this.$emit("playSensor", '暂停');
    }),
    clearYuan() {
      let circleWidth = document.getElementById("progressCircle").offsetWidth;
      this.dashArray = Math.PI * circleWidth;
      this.dashOffset = Math.PI * circleWidth;
    },
    //   播放结束自动切换下一首
    ended() {
      const {isios} = TestUserAgent();
      if (isios) {
        this.clearTime();
      }

      let circleWidth = document.getElementById("progressCircle").offsetWidth;
      this.dashArray = Math.PI * circleWidth;
      this.dashOffset = Math.PI * circleWidth;
      console.log("播放结束~~~");
      this.$emit("audio-end", this.audioInfo.only ? 1 : 0);
      this.$emit("playSensor", '暂停');
      //   // 初始化 圆形进度条的周长
    },
    // 操作音乐播放/暂停
    operation() {
      let audio = document.getElementById("audio");
      console.log(audio.paused, '**********')
      if (audio.paused) {
        audio.play();
        this.isStatus = true;
        this.$emit("playaudioparams", this.audioParams); //增加了播放量

        this.$emit("playSensor", '开始');
      } else {
        this.$emit("addPalyNum");
        this.$emit("playSensor", '暂停');
        audio.pause();
        this.isStatus = false;
        this.$emit("pauseaudioparams", this.audioParams);
      }

    },
    getCookie,
  },

  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const audio = this.$refs.player;
    this.$nextTick(() => {
      // 初始化圆的周长
      let circleWidth = document.getElementById("progressCircle").offsetWidth;
      this.dashArray = Math.PI * circleWidth;
      this.dashOffset = Math.PI * circleWidth;
    });
    // 实时获取音频当前播放时长
    audio.addEventListener("timeupdate", (e) => {
      this.current = Math.floor(e.target.currentTime);
      let duration = audio.duration;
      let percent = Math.min(1, this.current / duration) || 0;

      this.dashOffset = (1 - percent) * this.dashArray;
    });
  },
};
</script>
<style lang="less" scoped>
.font {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

/* 下面整体 */
.playmusic .bottom-music {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 12px;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10;
  width: 100%;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(221, 221, 221, 0.5);
  // opacity: 0.89;
}

/* 左边部分 */
.bottom-music {
  .lt-title {
    width: 220px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .music-lt {
    display: flex;
    align-items: center;

    .lt-avator {
      padding-right: 10px;
    }

    .title {
      font-size: 14px;
    }
  }
}

/* 环形进度条部分 */
.playmusic .bottom-music .music-rt {
  position: absolute;
  left: 9px;
}

.playmusic .bottom-music .music-rt .progress-circle {
  width: 50px;
  height: 50px;
}

.playmusic .bottom-music .music-rt .progress-circle circle {
  stroke-width: 3px;
  transform-origin: center;
}

.playmusic .bottom-music .music-rt .progress-circle .progress-background {
  transform: scale(0.9);
  //   stroke: yellow;
}

.playmusic .bottom-music .music-rt .progress-circle .progress-bar {
  transform: scale(0.9) rotate(-90deg);
  stroke: #ffe500;
}

.playmusic .bottom-music .music-rt .progress-circle .icons {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffe2bf84;
}

.playmusic .bottom-music .music-rt .menu {
  color: #ffe2bf84;
  font-weight: 500;
}

// 右边两个图标
.IconRight {
  display: flex;
  align-items: center;

  img:nth-of-type(1) {
    width: 28px;
    height: 28px;
  }

  img:nth-of-type(2) {
    padding-left: 10px;
    width: 20px;
    height: 20px;
  }
}

.img {
  width: 44px;
  height: 44px;
  display: table;
  vertical-align: middle;
  border-radius: 50%;
}

.rotation {
  transform: rotate(360deg);
  animation: rotation 3s linear infinite;
  -moz-animation: rotation 3s linear infinite;
  -webkit-animation: rotation 3s linear infinite;
  -o-animation: rotation 3s linear infinite;
}

.stop {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
</style>
